export function replaceHyphenAndUnderscoreAndLowerCase(
  stringToReplace: string,
): string {
  return stringToReplace.replace(/_|-/g, ' ').toLowerCase();
}
